import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle, Phone, Download } from "lucide-react";
import { whatsappLink, PHONE_TEL, PHONE_DISPLAY, CATALOGUE_URL } from "../data/constants";

const TRUST = ["100+ Commercial Projects", "Factory Wholesale Pricing", "Custom-Cut Dimensions"];

export function HeroSection() {
  return (
    <section data-testid="homepage-hero-section" className="px-4 pt-6 sm:px-8">
      <div className="navy-grid-bg relative mx-auto max-w-7xl overflow-hidden rounded-3xl border border-slate-800 p-6 text-white sm:p-10">
        <div className="absolute inset-0 z-0">
          <img src="https://images.unsplash.com/photo-1523633891499-c72d7aa7594f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600" alt="" className="h-full w-full object-cover opacity-25 blur-[2px]" />
          <div className="absolute inset-0 bg-[#0B1B3D]/85" />
        </div>
        <div className="relative z-10 max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#10B981]/40 bg-[#10B981]/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-[#6EE7B7]">
            Wholesale · B2B · Distribution
          </span>
          <h1 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Premium Flooring <span className="text-[#10B981]">&amp; Matting</span>
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
            Artificial grass, mats, carpets, felt & car mats for dealers, distributors, contractors and projects.
            Request a quote or chat with us directly — no carts, no checkout, just straight wholesale pricing.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/catalogue" data-testid="hero-explore-products-btn"
              className="group flex items-center gap-2 rounded-full bg-[#10B981] px-6 py-3 text-sm font-bold text-white shadow-lg transition-transform hover:scale-105">
              Explore Products <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <a href={CATALOGUE_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-download-catalogue-btn"
              className="flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-[#0B1B3D] shadow-lg transition-transform hover:scale-105">
              <Download className="h-4 w-4" /> Download Catalogue
            </a>
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-quote-btn"
              className="flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white shadow-lg transition-transform hover:scale-105">
              <MessageCircle className="h-4 w-4" /> WhatsApp Quote
            </a>
            <a href={`tel:${PHONE_TEL}`} data-testid="hero-call-now-btn"
              className="flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-white/10">
              <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
            </a>
          </div>

          <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3">
            {TRUST.map((t) => (
              <div key={t} className="flex items-center gap-2 text-sm font-medium text-slate-300">
                <span className="h-1.5 w-1.5 rounded-full bg-[#10B981]" /> {t}
              </div>
            ))}
          </div>
        </div>

        <div className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full bg-[#10B981]/10 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 right-20 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />
      </div>
    </section>
  );
}
